
import React, { useEffect, useContext } from 'react';
import { useUser } from '../../hook/UserHook';
import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';
import AuthenScreen from '../AuthenScreen';
import FooterInfo from '../FooterInfo';
import PrivacyPage from '../../../screens/PrivacyPage';

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function BaseScreen(props) {
    const { user, setUser } = useUser();
    let query = useQuery();
    const token = query.get('token');
    const [cookies] = useCookies(['user']);
    const location = useLocation();

    useEffect(() => {
        // if (token) {
        //     setToken(token);
        // } else 
        if (cookies && cookies.user)
            setUser(cookies.user)
        return () => { }
    }, [token])

    if (location.pathname === '/privacy') {
        return <><PrivacyPage /><FooterInfo /></>;
    }
    return <>{user ? props.children : <AuthenScreen />}<FooterInfo /></>;
}